module.exports = __webpack_public_path__ + "static/cta_projects@2x-934055131ae3b0b436ec87f6be4e20f9.jpg";